const Loading: React.FC = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="text-primary-600 mx-auto bg-transparent bg-none bg-no-repeat block fill-current"
        width="200px"
        height="200px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <path
          d="M10 50A40 40 0 0 0 90 50A40 44 0 0 1 10 50"
          fill="inherit"
          stroke="none"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            dur="1s"
            repeatCount="indefinite"
            keyTimes="0;1"
            values="0 50 52;360 50 52"
          ></animateTransform>
        </path>
      </svg>
    </div>
  );
};

export default Loading;
